import type { InputHTMLAttributes, ReactNode } from 'react';
import { useId } from 'react';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...rest }: InputProps) {
  return <input className={['au-input', className ?? ''].filter(Boolean).join(' ')} {...rest} />;
}

export interface FieldProps {
  label: string;
  error?: string;
  hint?: string;
  children: (id: string, invalid: boolean) => ReactNode;
}

/** Label + Eingabe + Fehler/Hinweis, korrekt per htmlFor/id verknüpft. */
export function Field({ label, error, hint, children }: FieldProps) {
  const id = useId();
  return (
    <div className="au-field">
      <label className="au-field__label" htmlFor={id}>
        {label}
      </label>
      {children(id, error !== undefined)}
      {error !== undefined ? (
        <span className="au-field__error" role="alert">
          {error}
        </span>
      ) : hint !== undefined ? (
        <span className="au-field__hint">{hint}</span>
      ) : null}
    </div>
  );
}
